import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'

const RiskLevel = ({ title, symbol, levelnum, onClick, extraClasses }) => {
  return (
    <span className={`risk-container ${extraClasses}`}>
      {title && (
        <span className="risk-header">
          {title}: {symbol && <sup>{symbol}</sup>}
        </span>
      )}
      <span onClick={onClick} className={`risk-level level${levelnum}`}>
        {levelnum}
      </span>
    </span>
  )
}

RiskLevel.propTypes = {
  title: PropTypes.string.isRequired,
  levelnum: PropTypes.string.isRequired,
  symbol: PropTypes.string,
  onClick: PropTypes.func,
  extraClasses: PropTypes.string
}

RiskLevel.defaultProps = {
  symbol: '',
  extraClasses: '',
  onClick: () => {}
}

export default RiskLevel
